<template>
  <fb-form-body>
    <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="fb-form">

      <el-form-item :label="$t('lang.标题')" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.内容')" prop="content">
        <el-input type="textarea" v-model="formData.content" :rows="5"></el-input>
      </el-form-item>


      <el-form-item class="form-item" :label="$t('lang.推送方式')" prop="pushType">
        <el-radio-group v-model="formData.pushType" @change="handleChangePushType">
          <el-row>
            <el-col>
              <el-radio label="all"><span class="radio-text">{{ $t('lang.全体发送') }}</span></el-radio>
            </el-col>

            <el-col class="mode-row">
              <el-radio label="region" style="margin-top: 24px">
                <span class="radio-text">{{ $t('lang.限定地区') }}</span>
                <Area @change="handleChangeArea" />
              </el-radio>
            </el-col>

            <el-col class="mode-row">
              <el-radio label="user" style="display: flex;align-items: center; width: 800px">
                <div style="display: flex; align-items: center">
                  <span class="radio-text">{{ $t('lang.自定义用户') }}</span>
                  <div class="file-row">
                    <span class="file-info">{{fileName || $t('lang.上传用户名单')}}</span>

                    <UploadFile type="application/sheet" :show-input="false" category="INFORM" @upload="handleUploadFile">
                      <span class="el-icon-upload upload-btn"></span>
                    </UploadFile>
                  </div>
                  <span style="color: #2f86dd;margin-left: 24px" @click="handleDownload">{{ $t('lang.Excel模板下载') }}</span>
                </div>

              </el-radio>
            </el-col>

            <el-col class="mode-row">
              <el-radio label="product" class="center">
                <div class="center">
                  <span class="radio-text">{{ $t('lang.限定型号') }}</span>
                  <el-checkbox-group v-model="formData.productCodes" class="checkbox" v-if="subBrandModel.length" @change="handleChangeModel">
                    <el-checkbox v-for="i in subBrandModel" :key="i.code" :label="i.code">{{ i.name }}</el-checkbox>
                  </el-checkbox-group>
                </div>

              </el-radio>
            </el-col>
          </el-row>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <el-checkbox v-model="formData.pushMode">
          <div>
            <span>{{ $t('lang.设为定时推送') }}</span>
            <el-date-picker
                v-model="formData.pushTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="handleChangePushTime">
            </el-date-picker>
          </div>
        </el-checkbox>
      </el-form-item>


      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.保存') }}</el-button>
        <el-button type="primary" @click="handleSaveAndPush('form')" v-show="!formData.pushMode">{{ $t('lang.保存并发送') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>
import Area from "../../components/area/Area";
import UploadFile from "../../components/upload-file/UploadFile";
import {downloadTemplate} from "../../js/common";

export default {
  name: "InformEdit",
  components: {UploadFile, Area},
  data() {
    return {
      api: {
        update: this.$api.inform.update,
        detail: this.$api.inform.detail,
        addAndPush: this.$api.inform.addAndPush,
      },
      formErrorMsg: {name: ''},
      formData: {
        code: '',
        title: '',
        content: '',
        pushType: 'all',
        pushMode: false,
        fileCode: "",
        productCodes: [],
        pushTime: ''
      },

      loading: false,

      areaInfo: {
        country: '',
        province: '',
        city: ''
      },
      fileName: ''
    }
  },
  computed: {
    rules() {
      let checkPushType = (rule, value, callback) => {
        let errorText = '';
        switch (this.formData.pushType) {
          case 'region':
            if(!this.areaInfo['country']) {
              errorText = this.$t('lang.限定地区不能为空');
            }
            break;
          case 'user':
            if(!this.formData['fileCode']) {
              errorText = this.$t('lang.自定义用户不能为空');
            }
            break;
          case 'product':
            if(!this.formData['productCodes'].length) {
              errorText = this.$t('lang.限定型号不能为空');
            }
            break;
        }
        if(errorText) return callback(new Error(errorText));
        return callback();
      };
      return {
        title: [
          {required: true, message: this.$t('lang.标题不能为空'), trigger: 'blur'}
        ],
            content: [
          {required: true, message: this.$t('lang.内容不能为空'), trigger: 'blur'}
        ],
            pushTime: [
          {required: true, message: this.$t('lang.推送时间不能为空'), trigger: 'blur'}
        ],
            pushType: [
          {required: true, validator: checkPushType, trigger: 'blur'}
        ],
      }
    },
    subBrandModel() {
      return this.$store.state.subBrandList;
    }
  },
  methods: {
    // 型号改变
    handleChangeModel(e) {
      this.formData['pushType'] = 'product';
      if(e.length) this.$refs.form.clearValidate('pushType');
    },
    // 上传用户文件
    handleUploadFile(e) {
      this.formData['pushType'] = 'user';
      let {file, data} = e;
      this.fileName = file.name;
      this.formData['fileCode'] = data.fileCode;
      this.$refs.form.clearValidate('pushType');
    },
    // 地区改变
    handleChangeArea(e) {
      this.formData['pushType'] = 'region';
      let index = 0;
      const vm = this;
      if(e.length) {
        for (const key in vm.areaInfo) {
          if(e[index]) {
            vm.areaInfo[key] = e[index].number;
          } else {
            vm.areaInfo[key] = '';
          }

          index ++;
        }
      }
    },
    // 推送方式改变
    handleChangePushType() {
      for (const areaInfoKey in this.areaInfo) {
        this.areaInfo[areaInfoKey] = '';
      }
      this.fileName = '';
      this.formData['fileCode'] = '';
      this.formData['productCodes'] = [];
    },
    // 推送时间改变
    handleChangePushTime() {
      this.formData.pushMode = true;
    },
    // 下载模板
    handleDownload() {
      downloadTemplate(this, this.$t(`lang.用户导入模版`) + '.xlsx');
    },
    handleSubmit(form) {
      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          let {pushType, code, title, content, pushMode, fileCode, productCodes, pushTime} = {...vm.formData};

          let data = {pushType, code, title, content, pushMode, fileCode, productCodes, pushTime};

          data['brandOwnerCode'] = vm.$store.state.userInfo['brandOwnerCode'];
          switch (data['pushType']) {
            case 'all':
              delete data['fileCode'];
              delete data['productCodes'];
              break;
            case 'user':
              delete data['productCodes'];
              break;
            case 'region':
              for (const key in vm.areaInfo) {
                data[key] = vm.areaInfo[key];
              }
              delete data['fileCode'];
              delete data['productCodes'];
              break;
            case 'product':
              data['productCodes'] = data['productCodes'].join(',');
              delete data['fileCode'];
              break;
          }

          if(data['pushMode'] && !data['pushTime']) {
            vm.$message.error(vm.$t('lang.定时推送时间不能为空'));
            return;
          } else if(data['pushMode']) {
            data['pushMode'] = 'timer';
          } else {
            data['pushMode'] = 'immediate';
            delete data['pushTime'];
          }


          vm.$http.post(vm.api.update, this.$qs.stringify(data)).then((resp) => {

            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              vm.$router.back();
            } else if (resp.data.status === 400) {

              console.log(vm.$refs[form]);




              if (resp.data.desc) {
                vm.$message({
                  type: "error",
                  message: resp.data.desc
                });
              }


            } else {
              vm.$message({
                type: "error",
                message: resp.data.desc
              })
            }

          });
          return true;
        } else {
          return false;
        }
      });

    },

    // 保存并推送
    handleSaveAndPush(form) {
      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          let {pushType, code, title, content, pushMode, fileCode, productCodes, pushTime} = {...vm.formData};

          let data = {pushType, code, title, content, pushMode, fileCode, productCodes, pushTime};

          data['brandOwnerCode'] = vm.$store.state.userInfo['brandOwnerCode'];
          switch (data['pushType']) {
            case 'all':
              delete data['fileCode'];
              delete data['productCodes'];
              break;
            case 'user':
              delete data['productCodes'];
              break;
            case 'region':
              for (const key in vm.areaInfo) {
                data[key] = vm.areaInfo[key];
              }
              delete data['fileCode'];
              delete data['productCodes'];
              break;
            case 'product':
              data['productCodes'] = data['productCodes'].join(',');
              delete data['fileCode'];
              break;
          }

          data['pushMode'] = data['pushMode'] ? 'timer' : 'immediate';

          console.log('data', data);


          vm.$http.post(vm.api.addAndPush, this.$qs.stringify(data)).then((resp) => {

            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              vm.$router.back();
            } else if (resp.data.status === 400) {

              console.log(vm.$refs[form]);




              if (resp.data.desc) {
                vm.$message({
                  type: "error",
                  message: resp.data.desc
                });
              }


            } else {
              vm.$message({
                type: "error",
                message: resp.data.desc
              })
            }

          });
          return true;
        } else {
          return false;
        }
      });

    },
    handleReset(form) {
      this.$refs[form].resetFields();
      this.handleChangePushType();
    }
  },

  created() {

    let vm = this;
    this.$http.post(this.api.detail, this.$qs.stringify(this.$route.query)).then(function (resp) {
      if(resp.data.status != 200) {
        vm.$message.error(resp.data.desc);
        return;
      }

      let data = resp.data.data['inform'];
      // 处理型号
      if(data['productCodes']) {
        data['productCodes'] = data['productCodes'].split(',')
      } else {
        data['productCodes'] = [];
      }

      // 处理地区
      vm.areaInfo['country'] = data['country'];
      vm.areaInfo['province'] = data['province'];
      vm.areaInfo['city'] = data['city'];

      data['pushMode'] =  data['pushMode'] === 'timer' ?  true : false;


      vm.formData = data;

    });

  }
}
</script>

<style scoped>

.fb-form {
  max-width: 500px;
}

.mode-row {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.radio-text {
  display: inline-block;
  width: 100px;
}

.center {
  display: flex;
  align-items: center;
}

.checkbox {
  border: 1px solid #dddddd;
  padding: 8px;
}

.file-row {
  display: flex;
  color: #606266 !important;
}

.file-info {
  line-height: 40px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid #dddddd;
  border-right: 0;
  cursor: default;
  border-radius: 4px 0 0 4px;
}

.upload-btn {
  display: inline-block;
  line-height: 40px;
  box-sizing: border-box;
  width: 60px;
  border: 1px solid #dddddd;
  font-size: 24px;
  border-radius: 0 4px 4px 0;
}

</style>
